import React, { useMemo } from "react";
import clsx from "clsx";
import { Box, Button, Card } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { NavLink } from "react-router-dom";
import { CLUB_INBODY_ROUTER } from "@icoach/router/routerPath";
import InBodyMeasurementTriggerButton from "@icoach/inbody/components/InBodyMeasurementTriggerButton";
import { IN_BODY_INTERVIEW_TABS, MEASURE_REFERENCE_TYPE } from "@icoach/constants";
import CommonTabs from "@icoach/components/layout/CommonTabs";
import { MemberInfoCard } from "@icoach/components";
import chibiCoachImg from "@images/chibiCoach.png";

/** ================================
 * 📌 教練摘要
 *  ================================
 */
const EmployeeInBodyEmployeeInfoSummary = ({ className, employeeID, sourceData: employeeData, activeTab }) => {
	const { nickName, employeeNo } = employeeData || {};

	const tabData = useMemo(
		() => {
			return [
				{
					label: "比較表",
					value: IN_BODY_INTERVIEW_TABS.COMPARE,
					component: NavLink,
					to: CLUB_INBODY_ROUTER.GET_EMPLOYEE_INTERVIEW_PATH(IN_BODY_INTERVIEW_TABS.COMPARE, employeeID),
				},
				{
					label: "量身紀錄",
					value: IN_BODY_INTERVIEW_TABS.MEASURE,
					component: NavLink,
					to: CLUB_INBODY_ROUTER.GET_EMPLOYEE_INTERVIEW_PATH(IN_BODY_INTERVIEW_TABS.MEASURE, employeeID),
				},
			];
		},
		// eslint-disable-next-line
		[employeeID]
	);

	return (
		<Card className={clsx("employees-summary-box", className)}>
			<Card.CardContent className="px-3 pt-3">
				<Grid spacing={3} container>
					<Grid item xs={8}>
						<MemberInfoCard className="mb-1" name={nickName} memberNo={employeeNo} avatar={chibiCoachImg} avatarWidth={9} isShowAvatar />
					</Grid>
					<Grid item xs={4}>
						<Box className="tool-btn-group text-right">
							<Button component={NavLink} to={CLUB_INBODY_ROUTER.GET_HISTORY_PATH(MEASURE_REFERENCE_TYPE.EMPLOYEE, employeeID)} variant="contained">
								返回列表
							</Button>
						</Box>
					</Grid>
				</Grid>
				<Box className="controller-box">
					<InBodyMeasurementTriggerButton />
				</Box>
			</Card.CardContent>
			<CommonTabs tabs={tabData} activeTab={activeTab} variant="scrollable" scrollButtons="auto" className="px-1" />
		</Card>
	);
};

export default EmployeeInBodyEmployeeInfoSummary;
